import { Component, Input, OnInit, EventEmitter, Output  } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ButtonInduxtry, SelectInput, Warning } from '../../../../../utils/models/input.interface';
import { returnColorWarning, returnTextWarning, returnWarningIcon } from '../../../functions/utilities.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { ButtonComponent } from '../button/button.component';
@Component({
  selector: 'select-input',
  templateUrl: './select-input.component.html',
  standalone: true,
  imports: [
    SharedModule,
    MatSelectModule,
    ButtonComponent
  ],
  styleUrls: ['./select-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SelectInputComponent,
    },
  ],
})
export class SelectInputComponent implements OnInit, ControlValueAccessor {
  warningIconSelectInput = returnWarningIcon;
  colorWarningSelectInput = returnColorWarning;
  textWarningSelectInput = returnTextWarning;

  @Input() selectInput: SelectInput;
  @Input() loading = false;
  @Input() warning: Warning;
  @Input() clearButton = false;

  buttonClear: ButtonInduxtry;
  valuePage = 1

  @Output() valueEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Output() endScroll: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() page: EventEmitter<number> = new EventEmitter<number>();


  writeValue(value: any): void {
    this.selectInput.value = value;
  }

  onChange = (value: any) => {
    return value;
  };

  onTouched = (value: unknown) => {
    return value;
  };

  registerOnChange(onChange: (value: any) => any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  ngOnInit(): void {
    this.buttonClear = { label: 'LIMPAR', elongated: true, customStyle: 'secondary', showLabel: true }
  }

  setNewValue() {
    this.onChange(this.selectInput.value);
    this.valueEmitter.emit({option: this.selectInput.value});
  }

  handleClear(value) {
    this.selectInput.value = '';
    this.valueEmitter.emit({option: ''});
  }

  onSelectScroll(value) {}

  infiniteScroll() {
    if(!this.loading){
      this.valuePage ++
      this.endScroll.emit(true)
      this.page.emit(this.valuePage)
    }
  }
}
